enum Alert {

  ALLERGIES = 'allergies',
  BIRTHDAY = 'birthday',
  FALL_RISK = 'fallRisk',
  ISOLATION = 'isolation',
  PREVENTIVE_MEDICINE = 'preventiveMedicine',
  VIP = 'vip',

}

export default Alert;
